export const pointsExtractConstants = {
	SET_SEARCHED_USER: 'SET_SEARCHED_USER',
	ADD_OPTIONS: 'ADD_OPTIONS'
}
